var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VARIANT_FRAGMENT_AVAILABILITY = exports.VARIANT_FRAGMENT = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const imageFragment_1 = require("./imageFragment");
const priceFragment_1 = require("./priceFragment");
exports.VARIANT_FRAGMENT = (0, graphql_tag_1.default)`
  fragment VariantFragment on ProductVariant {
    id
    sku
    title
    weight
    weightUnit
    availableForSale
    currentlyNotInStock
    quantityAvailable
    requiresShipping
    selectedOptions {
      name
      value
    }
    image {
      ...ImageFragment
    }
    ...PriceFragment
  }
  ${imageFragment_1.IMAGE_FRAGMENT}
  ${priceFragment_1.PRICE_FRAGMENT}
`;
exports.VARIANT_FRAGMENT_AVAILABILITY = (0, graphql_tag_1.default)`
  fragment VariantFragmentAvailability on ProductVariant {
    id
    sku
    availableForSale
    currentlyNotInStock
    quantityAvailable
    ...PriceFragment
  }
  ${priceFragment_1.PRICE_FRAGMENT}
`;